export const test_id = {
    type: String,
    default: ''
}
